import { Route, Routes } from 'react-router-dom';

import { css } from '@emotion/react'
import styled from '@emotion/styled'

// basic routes
import EditDiscount from '../components/Discounts/EditDiscount';


const Adjustments = () => {
  return (
    <Routes>
      {/* <Route path="/" element={<CustomerList />} /> */}
      <Route path="/edit/:id" element={<EditDiscount />} />
      <Route path="/edit" element={<EditDiscount />} />
      {/* <Route path="/view/:id" element={<ViewCustomer />} /> */}
    </Routes>
  )
}

export default Adjustments;